module.exports = __webpack_public_path__ + "img/mlt_845.61a34f00.jpg";